import React, { useEffect } from "react";

/**
 * Embeds the supplied HubSpot form using the v3 auto-loader script
 * (from the brief). Listens for the post-submit `hsFormCallback` event
 * and redirects to the supplied thank-you URL.
 *
 * Field set is NOT modified — rendered exactly as HubSpot serves it.
 */
export const HubSpotForm = ({
  portalId = "2534722",
  formId = "eac12394-2144-42bc-9b15-96551784341c",
  region = "ap1",
  redirectUrl = "https://connect.corsagroup.com.au/audit-thank-you",
  containerId = "audit-form",
  className = "",
}) => {
  useEffect(() => {
    const SCRIPT_SRC = `https://js-${region}.hsforms.net/forms/embed/${portalId}.js`;
    if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.defer = true;
      document.body.appendChild(s);
    }

    // HubSpot v3 dispatches a window message on successful submit.
    const onMessage = (event) => {
      const data = event?.data;
      if (!data) return;
      const isSubmitted =
        (data.type === "hsFormCallback" && data.eventName === "onFormSubmitted") ||
        data.eventName === "onFormSubmit" ||
        data.event === "onFormSubmitted" ||
        data.meetingBookSucceeded === true;
      if (isSubmitted) {
        // brief delay so HubSpot can finalise the request
        setTimeout(() => {
          window.location.href = redirectUrl;
        }, 350);
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [portalId, formId, region, redirectUrl]);

  return (
    <div
      id={containerId}
      data-testid="hubspot-form-wrap"
      className={`hs-form-wrap ${className}`}
    >
      <div
        className="hs-form-frame"
        data-region={region}
        data-form-id={formId}
        data-portal-id={portalId}
      />
    </div>
  );
};

export default HubSpotForm;
